import { Injectable } from '@angular/core';
import { KzDropdownComponent } from './kz-dropdown.component';

@Injectable()
export class KzDropdownService {

  public dropdowns: Array<KzDropdownComponent> = [];

  constructor() { }
}
